import { useRef } from 'react';
import CloseIcon from '@mui/icons-material/Close';

import './_modalComponent.scss';

import React from 'react';
import clsx from 'clsx';
import { createPortal } from 'react-dom';

import XIcon from '@/components/Icons/icons/XIcon';

type ModalComponentProps = {
  show: boolean;
  title?: string | React.ReactNode;
  centeredTitle?: string;
  width?: number | string;
  onClose: () => any;
  children?: React.ReactNode;
  outsideClickClose?: boolean;
  showCloseIcon?: boolean;
  style?: string | any;
  subtitle?: string;
  modalBackdrop?: 'light' | string;
  showDivider?: boolean;
  bodyStyle?: string | any;
  bgPadding?: boolean;
  topCross?: boolean;
  userPill?: {
    initials: string;
    name: string;
    onClick?: () => void;
  };
  footer?: React.ReactNode;
  className?: string;
  noPadding?: boolean;
  modalBgClassName?: string;
  titleClassName?: string;
  bodyClassName?: string;
  headerClassName?: string;
  closeIconDimensions?: {
    width?: number;
    height?: number;
  };
};

const ModalComponent = ({
  show,
  title,
  centeredTitle,
  width,
  onClose,
  children,
  outsideClickClose = true,
  showCloseIcon = false,
  style,
  subtitle,
  modalBackdrop = 'light',
  showDivider = false,
  bodyStyle = {},
  bgPadding = false,
  topCross = false,
  userPill,
  footer,
  className = '',
  noPadding = false,
  modalBgClassName = '',
  titleClassName = '',
  bodyClassName = '',
  headerClassName = '',
  closeIconDimensions = {
    width: 20,
    height: 20,
  },
}: ModalComponentProps) => {
  const modalRef: any = useRef();

  const handleOutsideClick = (e: any) => {
    if (!modalRef.current?.contains(e.target)) {
      if (outsideClickClose && show && onClose) {
        onClose();
      }
    }
  };
  return (
    <>
      {show &&
        createPortal(
          <div
            style={bgPadding ? { padding: '0' } : {}}
            className={`modal-bg ${modalBackdrop === 'light' ? 'modal-bg-light' : 'modal-bg-dark'} ${modalBgClassName}`}
            onClick={handleOutsideClick}>
            <div
              className={`modal-container ${className}`}
              style={{ width: width || 768, padding: noPadding && 0, ...style }}
              ref={modalRef}>
              {/* title */}
              <div className={`modal-header-section ${headerClassName}`}>
                <div className={clsx('modal-header-content', { 'items-start': subtitle })}>
                  <div>
                    {title && (
                      <h2
                        className={`modal-title ${titleClassName}`}
                        style={{ textAlign: centeredTitle ? 'center' : 'left' }}>
                        {title}
                      </h2>
                    )}
                    {subtitle && (
                      <p className="modal-subtitle" style={{ textAlign: centeredTitle ? 'center' : 'left' }}>
                        {subtitle}
                      </p>
                    )}
                  </div>
                  {userPill && (
                    <div
                      className={clsx('user-pill', { 'cursor-pointer': userPill.onClick })}
                      onClick={() => {
                        userPill.onClick && userPill.onClick();
                      }}>
                      {userPill.initials && <div className="user-initials">{userPill.initials}</div>}
                      {userPill.name && <span className="user-name">{userPill.name}</span>}
                    </div>
                  )}
                  {showCloseIcon && (
                    <button className="close-modal-btn" onClick={onClose}>
                      <XIcon
                        width={closeIconDimensions.width}
                        height={closeIconDimensions.height}
                        color="var(--icon-default)"
                      />
                    </button>
                  )}
                </div>

                {topCross && (
                  <button className="top-close-modal-btn" onClick={onClose}>
                    <CloseIcon fontSize="small" />
                  </button>
                )}
              </div>
              {showDivider && <div className="divider"></div>}
              <div className={`modal-body-section ${bodyClassName}`} style={{ padding: noPadding && 0, ...bodyStyle }}>
                {/* body of modal */}
                {children}
              </div>
              {footer && <div className="modal-footer-section">{footer}</div>}
            </div>
          </div>,
          document.body
        )}
    </>
  );
};

export default ModalComponent;
